(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('root-cause-analysis-factor', {
            parent: 'company_admin',
            url: '/root-cause-analysis-factor?page&sort&search',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN'],
                pageTitle: 'abcQualityMatchApp.rootCauseAnalysisFactor.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/company_admin/root-cause-analysis-factor/root-cause-analysis-factors.html',
                    controller: 'RootCauseAnalysisFactorController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'name,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('rootCauseAnalysisFactor');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('root-cause-analysis-factor-detail', {
            parent: 'company_admin',
            url: '/root-cause-analysis-factor/{id}',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN'],
                pageTitle: 'abcQualityMatchApp.rootCauseAnalysisFactor.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/company_admin/root-cause-analysis-factor/root-cause-analysis-factor-detail.html',
                    controller: 'RootCauseAnalysisFactorDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('rootCauseAnalysisFactor');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'RootCauseAnalysisFactor', function($stateParams, RootCauseAnalysisFactor) {
                    return RootCauseAnalysisFactor.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'root-cause-analysis-factor',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('root-cause-analysis-factor-detail.edit', {
            parent: 'root-cause-analysis-factor-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/company_admin/root-cause-analysis-factor/root-cause-analysis-factor-dialog.html',
                    controller: 'RootCauseAnalysisFactorDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['RootCauseAnalysisFactor', function(RootCauseAnalysisFactor) {
                            return RootCauseAnalysisFactor.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('root-cause-analysis-factor.new', {
            parent: 'root-cause-analysis-factor',
            url: '/new',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/company_admin/root-cause-analysis-factor/root-cause-analysis-factor-dialog.html',
                    controller: 'RootCauseAnalysisFactorDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                deleted: false,
                                id: null,
                                company:{}
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('root-cause-analysis-factor', null, { reload: 'root-cause-analysis-factor' });
                }, function() {
                    $state.go('root-cause-analysis-factor');
                });
            }]
        })
        .state('root-cause-analysis-factor.edit', {
            parent: 'root-cause-analysis-factor',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/company_admin/root-cause-analysis-factor/root-cause-analysis-factor-dialog.html',
                    controller: 'RootCauseAnalysisFactorDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['RootCauseAnalysisFactor', function(RootCauseAnalysisFactor) {
                            return RootCauseAnalysisFactor.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('root-cause-analysis-factor', null, { reload: 'root-cause-analysis-factor' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('root-cause-analysis-factor.delete', {
            parent: 'root-cause-analysis-factor',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/company_admin/root-cause-analysis-factor/root-cause-analysis-factor-delete-dialog.html',
                    controller: 'RootCauseAnalysisFactorDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['RootCauseAnalysisFactor', function(RootCauseAnalysisFactor) {
                            return RootCauseAnalysisFactor.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('root-cause-analysis-factor', null, { reload: 'root-cause-analysis-factor' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
